<template>
  <v-container class="container-pedido">
    <div class="gerador-pdf-fantasma">
        <impressao-pedido ref="geradorPdf" :modo-componente="true" />
    </div>

    <v-overlay :value="loading" opacity="0.8" z-index="9999">
      <div class="d-flex flex-column align-center justify-center">
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        <div class="white--text mt-3 font-weight-bold text-center">
          {{ statusMensagem }}
        </div>
      </div>
    </v-overlay>


    <v-row class="header-fixo elevation-2" >
      <v-col cols="12" class="d-flex justify-center pb-0">
        <v-btn
          small
          tile
          class="mx-1 rounded"
          :color="filtroTipo === 'pedido' ? 'primary' : 'white'"
          :class="filtroTipo === 'pedido' ? 'white--text' : 'grey--text text--darken-2'"
          @click="filtroTipo = 'pedido'"
        >
          Pedidos
        </v-btn>

        <v-btn
          small
          tile
          class="mx-1 rounded"
          :color="filtroTipo === 'orcamento' ? 'amber darken-2' : 'white'"
          :class="filtroTipo === 'orcamento' ? 'white--text' : 'grey--text text--darken-2'"
          @click="filtroTipo = 'orcamento'"
        >
          Orçamentos
        </v-btn>

        <v-btn
          small
          tile
          class="mx-1 rounded"
          :color="filtroTipo === 'precadastro' ? '#009688' : 'white'"
          :class="filtroTipo === 'precadastro' ? 'white--text' : 'grey--text text--darken-2'"
          @click="filtroTipo = 'precadastro'"
        >
          Pré-Cadastro
        </v-btn>
      </v-col>
      
      <v-col cols="12" class="pt-2 pt-0 d-flex justify-center">
        <v-card 
          outlined
          class="mx-4 d-flex align-center justify-space-between px-4 py-2 rounded"
          :style="{
            borderColor: corBordaFiltro + ' !important',
            borderWidth: '1px',
            width: '100%',
            maxWidth: '380px'
          }"
        >
          <v-checkbox
            v-model="todosSelecionados"
            label="Selecionar todos"
            hide-details
            class="ma-0 pa-0 font-weight-medium"
            :color="corCheckboxFiltro"
          ></v-checkbox>

          <v-chip
            small
            :color="corCheckboxFiltro"
            text-color="white"
            class="font-weight-bold"
          >
            {{ listaFiltrada.filter(p => p.selecionado).length }} / {{ listaFiltrada.length }}
          </v-chip>
        </v-card>
      </v-col>
      <v-col cols="12" class="pa-0 pb-2 d-flex justify-center">
        <v-btn
          dark
          small
          @click="enviarTransmissao"
          :style="{
            backgroundColor: corBordaFiltro
          }"
        >
          {{ textoBotaoEnviar }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="lista-com-padding">
      <v-col v-if="listaFiltrada.length === 0" cols="12" class="text-center py-8">
        <v-icon size="48" color="grey lighten-1">mdi-clipboard-text-outline</v-icon>
        <div class="grey--text text--darken-1 mt-2">
          Nenhum {{ filtroTipo === 'orcamento' ? 'orçamento' : (filtroTipo === 'precadastro' ? 'pré-cadastro' : 'pedido') }} pendente para envio.
        </div>
      </v-col>

      <!-- CARDS DE PEDIDOS / ORÇAMENTOS -->
      <template v-else-if="filtroTipo !== 'precadastro'">
        <v-col
          v-for="pedido in listaFiltrada"
          :key="'pedido-' + pedido.idpedido"
          cols="12"
          class="mb-3">
          <v-card class="mx-4 card">
            <div 
              class="card__consumidor d-flex flex-column" 
              :style="{
                border: pedido.orcamento === 1 ? '2px solid #ffa92d' : '2px solid #4c6faf',
                backgroundColor: '#ffffff',
                color: '#333333',
                cursor: 'pointer'
              }"
              @click="pedido.selecionado = !pedido.selecionado"
              v-ripple
            >
              <div 
                class="pa-2 mb-2 white--text font-weight-bold w-100 elevation-1" 
                :style="{
                  backgroundColor: pedido.orcamento === 1 ? '#ffa92d' : '#4c6faf',
                  fontSize: '0.90rem',
                  lineHeight: '1.3'
                }"
              >
                {{ pedido.clienteCodigo }} - 
                <span v-if="pedido.clinome">{{ pedido.clinome }}</span>
                <span v-else>CONSUMIDOR DIVERSOS</span>
              </div>

              <div class="d-flex justify-space-between align-start w-100 px-1">
                
                <div class="mr-3 mt-n1" @click.stop>
                  <v-checkbox
                    v-model="pedido.selecionado"
                    :color="pedido.orcamento === 1 ? 'amber darken-2' : 'primary'"
                    hide-details
                    class="ma-0 pa-0"
                  ></v-checkbox>
                </div>
                
                <div class="escrito__card d-flex flex-column flex-grow-1">
                  <span v-if="pedido.numeroExibicao" class="mb-1">
                    <b>Nº {{ pedido.orcamento === 1 ? 'Orçamento:' : 'Pedido:' }}</b> {{ pedido.numeroExibicao }}
                  </span>

                  <span v-if="pedido.data" class="mb-1">
                    <b>Pedido:</b> {{ FormataDataGeral(pedido.data) }}
                  </span>

                </div>

                <span v-if="pedido.total !== null && pedido.total !== undefined" class="d-flex align-center mt-auto">
                  <v-icon size="16" :color="pedido.orcamento === 1 ? '#ffa92d' : '#4c6faf'" class="mr-1">mdi-cash</v-icon>
                  <b style="font-size: 0.95rem;">{{ formatarValor(pedido.total) }}</b>
                </span>
              </div>
            </div>
          </v-card>
        </v-col>
      </template>

      <!-- CARDS DE PRÉ-CADASTRO -->
      <template v-else>
        <v-col
          v-for="lead in listaFiltrada"
          :key="'lead-' + lead.id"
          cols="12"
          class="mb-3">
          <v-card class="mx-4 card">
            <div 
              class="card__consumidor d-flex flex-column" 
              :style="{
                border: '2px solid #009688',
                backgroundColor: '#ffffff',
                color: '#333333',
                cursor: 'pointer'
              }"
              @click="lead.selecionado = !lead.selecionado"
              v-ripple
            >
              <div 
                class="pa-2 mb-2 white--text font-weight-bold w-100 elevation-1" 
                :style="{
                  backgroundColor: '#009688',
                  fontSize: '0.90rem',
                  lineHeight: '1.3'
                }"
              >
                {{ lead.id }} - 
                <span v-if="lead.cllnome">{{ lead.cllnome }}</span>
                <span v-else>NOME NÃO INFORMADO</span>
              </div>

              <div class="d-flex justify-space-between align-start w-100 px-2 pb-2">
                
                <div class="mr-3 mt-n1" @click.stop>
                  <v-checkbox
                    v-model="lead.selecionado"
                    color="#009688"
                    hide-details
                    class="ma-0 pa-0"
                  ></v-checkbox>
                </div>
                
                <div class="escrito__card d-flex flex-column flex-grow-1">
                  <span v-if="lead.cllnomefantasia" class="mb-1">
                    <b>Fantasia:</b> {{ lead.cllnomefantasia }}
                  </span>

                  <span v-if="lead.cllcnpjCpf" class="mb-1">
                    <b>{{ lead.clltipopessoa === 'J' ? 'CNPJ:' : 'CPF:' }}</b> {{ formatarCpfCnpj(lead.cllcnpjCpf) }}
                  </span>

                  <span v-if="lead.cllcidade || lead.clluf" class="mb-1">
                    <b>Cidade:</b> {{ lead.cllcidade || '' }}<span v-if="lead.cllcidade && lead.clluf"> - </span>{{ lead.clluf || '' }}
                  </span>

                  <span v-if="lead.clltelefone || lead.cllcelular" class="mb-1">
                    <b>Contato:</b> {{ lead.clltelefone || lead.cllcelular }}
                  </span>

                  <span v-if="lead.clldatadigitacao" class="mb-1">
                    <b>Digitado em:</b> {{ FormataDataGeral(lead.clldatadigitacao) }}
                  </span>
                </div>

              </div>
            </div>
          </v-card>
        </v-col>
      </template>
    </v-row>  


    <v-dialog v-model="dialogSemConexao" max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">Sem Conexão</v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">O aparelho não está conectado à Internet. Verifique sua conexão e tente novamente.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogSemConexao = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUrl" max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">Configuração Incompleta</v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">A URL do servidor não está configurada. Realize uma Carga de dados primeiro.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" class="primary" text @click="dialogUrl = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmar" max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">Confirmar Transmissão</v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">{{ textoDialogConfirmar }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="dialogConfirmar = false">Cancelar</v-btn>
          <v-btn color="white" class="primary" text @click="iniciarTransmissao">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogResultado.show" max-width="450">
      <v-card>
        <v-card-title :class="`headline ${dialogResultado.color} white--text`">
          <v-icon left dark>{{ dialogResultado.icon }}</v-icon>
          {{ dialogResultado.title }}
        </v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text" v-html="dialogResultado.message"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogResultado.show = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-container>
</template>

<script>
import db from '@/plugins/dexie';

import moment from 'moment';
import ImpressaoPedido from '@/views/pedido/impressaopedido/Index.vue';
import 'simplebar-vue/dist/simplebar.min.css';
import { VENDEDOR_STORAGE } from '@/constants/STORAGE';

export default {
  name: 'ViewPedido',

  components: {
    ImpressaoPedido,
  },

  data() {
    return {
      pedidos: [],
      precadastros: [],
      loading: false,
      filtroTipo: 'pedido',
      dialogVendedorNaoLogado: false,

      idVendedor: 0,
      nomeVendedor: '',
      idEmpresa: 0,
      senha: '',
      baseUrl: '',
      statusMensagem: 'Processando...',
      limpezaDialog: false,
      dialogSemConexao: false,
      dialogUrl: false,
      dialogConfirmar: false,
      urlApiNodeEmail: 'https://oagrobrasil.com.br/apiemail',
      dialogResultado: {
        show: false,
        title: '',
        message: '',
        icon: '',
        color: ''
      },
    };
  },

  async mounted() {
    await this.carregarConfiguracoes();
    if (Object.keys(this.$route.query).length === 0) {
      this.carregarPedidos();
      this.carregarPrecadastros();
    }
  },

  computed: {

    todosSelecionados: {
      get() {
        if (this.listaFiltrada.length === 0) return false;
        return this.listaFiltrada.every(item => item.selecionado);
      },
      set(valor) {
        this.listaFiltrada.forEach(item => {
          item.selecionado = valor;
        });
      }
    },

    corBordaFiltro() {
      if (this.filtroTipo === 'orcamento') return '#ffa92d';
      if (this.filtroTipo === 'precadastro') return '#009688';
      return '#4c6faf';
    },

    corCheckboxFiltro() {
      if (this.filtroTipo === 'orcamento') return 'amber darken-2';
      if (this.filtroTipo === 'precadastro') return '#009688';
      return 'primary';
    },

    textoBotaoEnviar() {
      if (this.filtroTipo === 'orcamento') return 'Enviar Orçamentos';
      if (this.filtroTipo === 'precadastro') return 'Enviar Pré-Cadastros';
      return 'Enviar Pedidos';
    },

    textoDialogConfirmar() {
      if (this.filtroTipo === 'precadastro') {
        return 'Deseja transmitir os Pré-Cadastros selecionados?';
      }
      if (this.filtroTipo === 'orcamento') {
        return 'Deseja transmitir os Orçamentos selecionados?';
      }
      return 'Deseja transmitir Pedidos, Visitas e Clientes pendentes?';
    },

    listaFiltrada() {
      if (this.filtroTipo === 'todos') {
        return this.pedidos;
      }
      
      if (this.filtroTipo === 'orcamento') {
        return this.pedidos.filter(p => p.orcamento === 1);
      }
      
      if (this.filtroTipo === 'pedido') {
        return this.pedidos.filter(p => p.orcamento !== 1);
      }

      if (this.filtroTipo === 'precadastro') {
        return this.precadastros;
      }
      
      return this.pedidos;
    }
  },

  created() {
    sessionStorage.removeItem('filtro_historico_produto');
    sessionStorage.removeItem('produto_selecionado_retorno');
    sessionStorage.removeItem('itensVisuaisLaranja');
    sessionStorage.removeItem('pedidoAtualItens');
    sessionStorage.removeItem('retornoIdPedido');
    sessionStorage.removeItem('retornoIdCliente');
    sessionStorage.removeItem('vendasView_clienteAtual');
  },

  methods: {
    async carregarConfiguracoes() {
      try {
        const params = await db.parametro.toArray();
        
        if (params.length > 0) {
          const param = params[params.length - 1];
          this.idEmpresa = param.empresa ? parseInt(param.empresa) : 1;
          const urlDoBanco = param.linkwebservice; 

          if (urlDoBanco && typeof urlDoBanco === 'string' && urlDoBanco.trim().length > 0) {
            this.baseUrl = urlDoBanco.trim();
            if (!this.baseUrl.endsWith('/')) {
              this.baseUrl += '/';
            }
          }
        }

        const userIdStorage = sessionStorage.getItem(VENDEDOR_STORAGE.venidnuvem);

        if (userIdStorage && userIdStorage !== 'null' && userIdStorage !== 'undefined') {
          
          let user = null;
          const idParseado = parseInt(userIdStorage);

          if (!isNaN(idParseado)) {
            user = await db.vendedor.where('idvendedor').equals(idParseado).first();
          }

          if (!user) {
            user = await db.vendedor.where('idvendedor').equals(userIdStorage).first();
          }
          if (user) {
            this.idVendedor = parseInt(user.venidnuvem) || parseInt(user.codigo) || parseInt(user.idvendedor) || 0;
            this.senha = user.vensenha || user.senha || ''; 
            this.nomeVendedor = user.vennome || user.nome || '';
          }
        }

      } catch (err) {
        console.error("Erro ao carregar configurações (carregarConfiguracoes):", err);
      }
    },

    async fetchWcf(metodo, dataToSend, verboHttp = 'POST') {
      if (!this.baseUrl) {
        await this.carregarConfiguracoes();
        if (!this.baseUrl) throw new Error("URL do servidor não configurada.");
      }

      const url = `${this.baseUrl}${metodo}?ChaveSistema=m1cr0s3rv`;
      
      const headers = { 
        'Content-Type': 'application/json' 
      };

      try {
        const registroEmpresa = await db.empresa.limit(1).first();
        if (registroEmpresa && registroEmpresa.EMPChaveAppVenda) {
          headers['Authorization'] = registroEmpresa.EMPChaveAppVenda;
        }
      } catch (err) {
        console.warn("Não foi possível carregar a chave da empresa para o header:", err);
      }

      try {
        const response = await fetch(url, {
          method: verboHttp,
          headers: headers,
          body: JSON.stringify(dataToSend),
        });

        if (!response.ok) {
          if (response.status === 401) throw new Error("Transmissão recusada: Chave da Empresa Inválida (401).");
          if (response.status === 404) throw new Error(`Rota não encontrada no servidor: ${metodo}`);
          if (response.status === 500) throw new Error("Erro interno no Servidor (500).");
          throw new Error(`Erro HTTP ${response.status}`);
        }

        return await response.json();

      } catch (error) {
        if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
          throw new Error("Falha de Conexão. Verifique se o servidor está ligado e acessível.");
        }
        throw error;
      }
    },

    toggleSelecionarTodos() {
      const novoEstado = !this.todosSelecionados;
      
      this.listaFiltrada.forEach(item => {
        item.selecionado = novoEstado;
      });
    },
    
    abrirDetalhesPedido(pedido) {
      this.$router.push({
        path: '/cadastro-pedido',
        query: { 
          idpedido: pedido.idpedido,
          idpedidoditemd: pedido.idpedidoditemd,
        }
      });
      // console.log('teste', pedido.idpedidoditemd, 'id', pedido.id )
    },

    abrirPrecadastro(lead) {
      if (!lead || !lead.id) return;
      this.$router.push({
        path: '/precadastro',
        query: { id: lead.id }
      });
    },

    FormataDataGeral(date) {
      if (!date) return '';
      return moment.utc(date).format('DD/MM/YYYY HH:mm'); 
    },

    formatarCpfCnpj(valor) {
      if (!valor) return '';
      const digitos = String(valor).replace(/\D/g, '');
      if (digitos.length === 11) return digitos.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      if (digitos.length === 14) return digitos.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      return valor;
    },

    formatarValor(valor) {
      if (!valor) return '0,00';
      return valor.toLocaleString('pt-BR', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      });
    },

    getTabelaLeads() {
      return db.clientelead || db.clienteleads || db.clienteprecadastro;
    },

    async carregarPrecadastros() {
      try {
        const tabelaLeads = this.getTabelaLeads();
        if (!tabelaLeads) {
          this.precadastros = [];
          return;
        }

        let leads = await tabelaLeads.toArray();
        leads = leads.filter(l => l.atendido != 1);

        let idVendedorLogado = null;
        try {
          const paramsDb = await db.parametro.toArray();
          if (paramsDb.length > 0) {
            idVendedorLogado = paramsDb[0].idvendedorlogado;
          }
        } catch (e) {
          console.error("Erro ao recuperar vendedor logado para pré-cadastro:", e);
        }

        if (idVendedorLogado) {
          leads = leads.filter(l => !l.cllidvendedor || String(l.cllidvendedor) === String(idVendedorLogado));
        }

        leads.sort((a, b) => (b.id || 0) - (a.id || 0));

        this.precadastros = leads.map(lead => ({
          ...lead,
          selecionado: false,
        }));
      } catch (error) {
        console.error("Erro ao carregar pré-cadastros:", error);
        this.precadastros = [];
      }
    },

    async carregarPedidos() {
      this.loading = true;
      
      let idVendedorLogado = null;
      try {
        const paramsDb = await db.parametro.toArray();
        if (paramsDb.length > 0) {
          idVendedorLogado = paramsDb[0].idvendedorlogado; 
        }
      } catch (e) {
        console.error("Erro ao recuperar vendedor logado para o filtro:", e);
      }

      const codigopessoa = this.$route.query.codigopessoa;
      const nomecliente = this.$route.query.nomecliente;
      const idtipopedidovenda = this.$route.query.idtipopedidovenda;

      const createdFrom = this.$route.query['created-from'];
      const createdBefore = this.$route.query['created-before'];

      let collection = db.pedido;
      let pedidosFiltrados = [];

      try {
        if (codigopessoa) {
          const codInt = parseInt(codigopessoa, 10);
          pedidosFiltrados = await collection
            .where('idcliente')
            .equals(codInt)
            .and(p => !p.datalimpeza)
            .toArray();
            
          pedidosFiltrados.reverse();
        } else if (nomecliente) {
          const clientes = await db.cliente
            .filter(c => c.nome.toLowerCase().includes(nomecliente.toLowerCase()))
            .toArray();
          const clienteIDs = clientes.map(c => c.idcliente);
          
          pedidosFiltrados = await collection
            .where('idcliente')
            .anyOf(clienteIDs)
            .and(p => !p.datalimpeza)
            .toArray();
            
          pedidosFiltrados.reverse();
        } else {
          pedidosFiltrados = await collection
            .orderBy('idpedido')
            .reverse()
            .and(p => !p.datalimpeza)
            .limit(200)
            .toArray();
        }

        pedidosFiltrados = pedidosFiltrados.filter(p => {
          let valido = true;

          if (p.atendido == 1) {
            valido = false;
          }

          if (idVendedorLogado && String(p.idvendedor) !== String(idVendedorLogado)) {
            valido = false;
          }

          const dataPedidoFormatada = p.data ? moment(p.data).format('YYYY-MM-DD') : '';

          if (createdFrom) {
            if (dataPedidoFormatada < createdFrom) valido = false;
          }
          
          if (createdBefore && valido) {
            if (dataPedidoFormatada > createdBefore) valido = false;
          }

          if (idtipopedidovenda && valido) {
            if (String(p.idtipopedidovenda) !== String(idtipopedidovenda)) valido = false;
          }

          return valido;
        });

        const pedidosCompletos = await Promise.all(
          pedidosFiltrados.map(async (pedido) => {
            let cliente = await db.cliente.where('idcliente').equals(pedido.idcliente).first();
            if (!cliente && !isNaN(parseInt(pedido.idcliente))) {
              cliente = await db.cliente.where('idcliente').equals(parseInt(pedido.idcliente)).first();
            }
            if (!cliente) {
              const tabelaLeads = this.getTabelaLeads();
              if (tabelaLeads) {
                const idLeadNum = parseInt(pedido.idcliente);
                let lead = null;
                if (!isNaN(idLeadNum)) {
                  lead = await tabelaLeads.get(idLeadNum) || await tabelaLeads.where('cllidclienteprecadastro').equals(idLeadNum).first();
                }
                if (lead) {
                  cliente = {
                    nome: lead.cllnome,
                    idcliente: lead.id
                  };
                }
              }
            }
            let nomeTipoPedido = pedido.idtipopedidovenda;
            if (pedido.idtipopedidovenda) {
              let tipoObj = await db.tipopedidovenda
                .where('idtipopedidovenda')
                .equals(pedido.idtipopedidovenda)
                .first();

              if (!tipoObj) {
                const idNumero = parseInt(pedido.idtipopedidovenda);
                if (!isNaN(idNumero)) {
                  tipoObj = await db.tipopedidovenda
                    .where('idtipopedidovenda')
                    .equals(idNumero)
                    .first();
                }
              }

              if (!tipoObj) {
                tipoObj = await db.tipopedidovenda
                    .where('idtipopedidovenda')
                    .equals(String(pedido.idtipopedidovenda))
                    .first();
              }
                
              if (tipoObj && tipoObj.descricao) {
                nomeTipoPedido = tipoObj.descricao;
              }
            }
            let itens = await db.pedidoitem.where('idpedido').equals(pedido.idpedido).toArray();
            if (itens.length === 0) {
              itens = await db.pedidoitem.where('idpedido').equals(String(pedido.idpedido)).toArray();
              if (itens.length === 0) {
                itens = await db.pedidoitem.where('idpedido').equals(Number(pedido.idpedido)).toArray();
              }
            }
            
            const itensComDescricao = await Promise.all(itens.map(async (item) => {
              let descricaoProduto = 'Produto sem nome';
              
              if (item.idcortamanhofinal) {
                const prod = db.produto ? await db.produto.get(item.idcortamanhofinal) : null;
                if (prod) {
                  descricaoProduto = prod.descricao || prod.nome || prod.referencia; 
                } else {
                  descricaoProduto = `Cód. ${item.idcortamanhofinal}`;
                }
              }

              const qtd = item.quantidade || 0;
              const vlrUnitario = item.valorunitario || 0;
              const vlrDesconto = item.valordesconto || 0; 
              const vlrLiquido = vlrUnitario - vlrDesconto;

              return {
                ...item,
                descricao: descricaoProduto,
                quantidade: qtd,
                valorunitario: vlrUnitario,
                valordesconto: vlrDesconto,
                valorliquido: vlrLiquido,
                subtotal: qtd * vlrLiquido
              };
            }));

            const totalCalculado = itensComDescricao.reduce((sum, item) => {
              return sum + item.subtotal; 
            }, 0);

            return {
              ...pedido,
              numeroExibicao: pedido.idpedido, 
              clinome: cliente ? cliente.nome : 'CLIENTE NÃO ENCONTRADO',
              clienteCodigo: pedido.idcliente,
              observacao: pedido.observacao,
              descricaoTipo: nomeTipoPedido,
              data: pedido.data,
              total: totalCalculado > 0 ? totalCalculado : (pedido.total || 0),
              itens: itensComDescricao,
              showItems: false,
              selecionado: false
            };
          })
        );

        this.pedidos = pedidosCompletos;

      } catch (error) {
        console.error("Erro ao carregar pedidos:", error);
      } finally {
        this.loading = false;
      }
    },


    async processarEnvioVisitasDoPedido(idPedidoLocal, idPedidoBack, idOrcamentoBack) {
      this.statusMensagem = "Enviando Visitas...";
      let qtdEnviada = 0;

      const visitasPendentes = await db.visita
        .where('atendido')
        .notEqual(1)
        .filter(v => String(v.idpedido) === String(idPedidoLocal))
        .toArray();

      if (visitasPendentes.length === 0) return 0;

      for (const visita of visitasPendentes) {
        try {
          const idVendedorFinal = parseInt(visita.idvendedor) || this.idVendedor || 0;

          let lat = null;
          let long = null;

          if (visita.latitude) {
            const latStr = String(visita.latitude).replace(',', '.');
            const latVal = parseFloat(latStr);
            if (!isNaN(latVal)) lat = latVal;
          }

          if (visita.longitude) {
            const longStr = String(visita.longitude).replace(',', '.');
            const longVal = parseFloat(longStr);
            if (!isNaN(longVal)) long = longVal;
          }

          const dataVisitaFormatada = this.formatarDataSQL(visita.datavisita || new Date());
          const dataDigitacaoFormatada = this.formatarDataSQL(visita.datadigitacao || new Date());
          const idCliente = parseInt(visita.idcliente);
          
          if (isNaN(idCliente) || idCliente <= 0) continue; 

          let motivoId = parseInt(visita.motivo);
          if (isNaN(motivoId) || motivoId === 0) motivoId = null; 

          const payload = {
            VEVIdCliente: idCliente,
            VEVIdVendedor: idVendedorFinal,
            VEVDataVisita: dataVisitaFormatada,    
            VEVDataDigitacao: dataDigitacaoFormatada, 
            VEVMotivo: motivoId, 
            VEVObservacao: visita.observacao ? String(visita.observacao).substring(0, 250) : "",
            VEVLatitude: lat,
            VEVLongitude: long,
            VEVIdEmpresa: this.idEmpresa || 1,
            VEVIdPedidoVenda: idPedidoBack || null,
            VEVIdOrcamentoVenda: idOrcamentoBack || null,
          };

          const rota = visita.visidnuvem ? `visita/${visita.visidnuvem}` : 'visita/';
          const verbo = visita.visidnuvem ? 'PUT' : 'POST';
          const result = await this.fetchWcf(rota, payload, verbo);
          
          if (result) {
            await db.visita.update(visita.idvisita, { 
              atendido: 1,
              visidnuvem: result.VEVIdVendedorVisita || result.IdVisita || visita.visidnuvem || null,
              VEVIdPedidoVenda: idPedidoBack || null,
              VEVIdOrcamentoVenda: idOrcamentoBack || null
            });
            qtdEnviada++;
          }

        } catch (e) {
          console.error("Erro na visita ID:", visita.idvisita, e);
        }
      }
      
      return qtdEnviada;
    },

    async processarEnvioVisitasSemPedido() {
      this.statusMensagem = "Enviando Visitas Sem Pedido...";
      let qtdEnviada = 0;

      const visitasPendentes = await db.visita
        .where('atendido')
        .notEqual(1)
        .filter(v => !v.idpedido)
        .toArray();

      if (visitasPendentes.length === 0) return 0;

      for (const visita of visitasPendentes) {
        try {
          const idVendedorFinal = parseInt(visita.idvendedor) || this.idVendedor || 0;

          let lat = null;
          let long = null;

          if (visita.latitude) {
            const latStr = String(visita.latitude).replace(',', '.');
            const latVal = parseFloat(latStr);
            if (!isNaN(latVal)) lat = latVal;
          }

          if (visita.longitude) {
            const longStr = String(visita.longitude).replace(',', '.');
            const longVal = parseFloat(longStr);
            if (!isNaN(longVal)) long = longVal;
          }

          const dataVisitaFormatada = this.formatarDataSQL(visita.datavisita || new Date());
          const dataDigitacaoFormatada = this.formatarDataSQL(visita.datadigitacao || new Date());
          const idCliente = parseInt(visita.idcliente);
          
          if (isNaN(idCliente) || idCliente <= 0) continue; 

          let motivoId = parseInt(visita.motivo);
          if (isNaN(motivoId) || motivoId === 0) motivoId = null; 

          const payload = {
            VEVIdCliente: idCliente,
            VEVIdVendedor: idVendedorFinal,
            VEVDataVisita: dataVisitaFormatada,
            VEVDataDigitacao: dataDigitacaoFormatada, 
            VEVMotivo: motivoId, 
            VEVObservacao: visita.observacao ? String(visita.observacao).substring(0, 250) : "",
            VEVLatitude: lat,
            VEVLongitude: long,
            VEVIdEmpresa: this.idEmpresa || 1,
            VEVIdPedidoVenda: null,
            VEVIdOrcamentoVenda: null,
          };

          const rota = visita.visidnuvem ? `visita/${visita.visidnuvem}` : 'visita/';
          const verbo = visita.visidnuvem ? 'PUT' : 'POST';
          const result = await this.fetchWcf(rota, payload, verbo);
          
          if (result) {
            await db.visita.update(visita.idvisita, { 
              atendido: 1,
              visidnuvem: result.VEVIdVendedorVisita || result.IdVisita || visita.visidnuvem || null,
              VEVIdPedidoVenda: null,
              VEVIdOrcamentoVenda: null
            });
            qtdEnviada++;
          }

        } catch (e) {
          console.error("Erro na visita sem pedido ID:", visita.idvisita, e);
        }
      }
      
      return qtdEnviada;
    },

    async enviarUmClienteLead(lead) {
      try {
        const idVendedorFinal = parseInt(lead.cllidvendedor) || this.idVendedor || 0;

        const payload = {
          CLLtipopessoa: lead.clltipopessoa,
          CLLnome: lead.cllnome ? String(lead.cllnome).trim() : '',
          CLLnomefantasia: lead.cllnomefantasia ? String(lead.cllnomefantasia).trim() : '',
          CLLcnpjCpf: lead.cllcnpjCpf ? String(lead.cllcnpjCpf).replace(/\D/g, '') : '',
          CLLrgInscricao: lead.cllrgInscricao ? String(lead.cllrgInscricao).trim() : '',
          CLLdataNascimentoAbertura: lead.clldataNascimentoAbertura ? lead.clldataNascimentoAbertura : null,
          CLLcep: lead.cllcep ? String(lead.cllcep).replace(/\D/g, '') : '',
          CLLendereco: lead.cllendereco ? String(lead.cllendereco).trim() : '',
          CLLnumero: lead.cllnumero ? String(lead.cllnumero).trim() : '',
          CLLcomplemento: lead.cllcomplemento ? String(lead.cllcomplemento).trim() : '',
          CLLbairro: lead.cllbairro ? String(lead.cllbairro).trim() : '',
          CLLcidade: lead.cllcidade ? String(lead.cllcidade).trim() : '',
          CLLuf: lead.clluf ? String(lead.clluf).trim() : '',
          CLLtelefone: lead.clltelefone ? String(lead.clltelefone).replace(/\D/g, '') : '',
          CLLcelular: lead.cllcelular ? String(lead.cllcelular).replace(/\D/g, '') : '',
          CLLcontato: lead.cllcontato ? String(lead.cllcontato).trim() : '',
          CLLemail: lead.cllemail ? String(lead.cllemail).trim() : '',
          CLLemailNfe: lead.cllemailNfe ? String(lead.cllemailNfe).trim() : '',
          CLLemailFinanceiro: lead.cllemailFinanceiro ? String(lead.cllemailFinanceiro).trim() : '',
          CLLDataCadastro: this.formatarDataSQL(lead.clldatadigitacao),
          CLLidvendedor: idVendedorFinal || null,
          CLLIdEmpresa: this.idEmpresa || 1,
        };

        const idNuvem = lead.cllidnuvem;
        const rota = idNuvem ? `clientelead/${idNuvem}` : 'clientelead';
        const verbo = idNuvem ? 'PUT' : 'POST';
        const result = await this.fetchWcf(rota, payload, verbo);

        if (result) {
          const idGerado = result.CLLIdClienteLead || result.CLLidclienteprecadastro || result.IdClientePreCadastro || result.IdCliente || result.Id || result.id || idNuvem || null;
          const tabelaLeads = this.getTabelaLeads();
          if (tabelaLeads) {
            await tabelaLeads.update(lead.id, {
              atendido: 1,
              enviar: 0,
              cllidnuvem: idGerado,
            });
          }
          return idGerado || true;
        }
      } catch (e) {
        console.error("Erro ao enviar pré-cadastro de cliente ID:", lead.id, e);
        throw e;
      }
      return null;
    },

    async processarEnvioClientesLeadDoPedido(idClientePedido) {
      if (!idClientePedido) return 0;
      this.statusMensagem = "Enviando Clientes (Pré-Cadastro)...";
      let qtdEnviada = 0;

      try {
        const tabelaLeads = this.getTabelaLeads();
        if (!tabelaLeads) return 0;

        const idNum = parseInt(idClientePedido);
        const leads = await tabelaLeads.toArray();
        const leadsPendentes = leads.filter(l => {
          if (l.atendido == 1) return false;
          if (idNum && (l.id === idNum || l.cllidclienteprecadastro === idNum)) return true;
          if (String(l.id) === String(idClientePedido) || String(l.cllidclienteprecadastro) === String(idClientePedido)) return true;
          return false;
        });

        for (const lead of leadsPendentes) {
          try {
            const res = await this.enviarUmClienteLead(lead);
            if (res) qtdEnviada++;
          } catch (e) {
            console.error("Erro ao enviar lead do pedido:", lead.id, e);
          }
        }
      } catch (err) {
        console.error("Erro ao processar envio de clientes do pedido:", err);
      }

      return qtdEnviada;
    },

    async processarEnvioClientesLeadSemPedido() {
      this.statusMensagem = "Enviando Clientes Pré-Cadastro Sem Pedido...";
      let qtdEnviada = 0;

      try {
        const tabelaLeads = this.getTabelaLeads();
        if (!tabelaLeads) return 0;

        const leads = await tabelaLeads.toArray();
        const leadsPendentes = leads.filter(l => l.atendido != 1 && (l.enviar == 1 || l.enviar === true || l.enviar === '1'));

        if (leadsPendentes.length === 0) return 0;

        for (const lead of leadsPendentes) {
          try {
            const res = await this.enviarUmClienteLead(lead);
            if (res) qtdEnviada++;
          } catch (e) {
            console.error("Erro no envio de cliente pré-cadastro sem pedido ID:", lead.id, e);
          }
        }
      } catch (err) {
        console.error("Erro ao processar envio de clientes pré-cadastro sem pedido:", err);
      }

      return qtdEnviada;
    },

    async processarEnvioPrecadastrosSelecionados() {
      this.statusMensagem = "Enviando Pré-Cadastros...";
      let qtdEnviada = 0;
      let qtdFalhas = 0;

      const leadsPendentes = this.precadastros.filter(lead => lead.selecionado === true && lead.atendido != 1);

      if (leadsPendentes.length === 0) {
        return { clientes: 0, falhas: 0 };
      }

      for (const lead of leadsPendentes) {
        try {
          const res = await this.enviarUmClienteLead(lead);
          if (res) {
            qtdEnviada++;
          } else {
            qtdFalhas++;
          }
        } catch (e) {
          console.error(`Erro ao enviar pré-cadastro ID ${lead.id}:`, e);
          qtdFalhas++;
        }
      }

      return { clientes: qtdEnviada, falhas: qtdFalhas };
    },

    async processarEnvioPedidos() {
      this.statusMensagem = "Enviando Pedidos/Orçamentos...";
      let qtdPedidosEnviados = 0;
      let qtdOrcamentosEnviados = 0;
      let qtdVisitasEnviadas = 0;
      let qtdClientesEnviados = 0;
      let qtdFalhas = 0;

      let pedidosPendentes = this.pedidos.filter(pedido => pedido.selecionado === true);
      pedidosPendentes = pedidosPendentes.filter(pedido => pedido.atendido != 1);

      if (pedidosPendentes.length === 0) {
        return { pedidos: 0, orcamentos: 0, visitas: 0, clientes: 0, falhas: 0 };
      }

      for (const pedido of pedidosPendentes) {
        try {
          const idBusca = parseInt(pedido.idpedido);
          
          let itens = await db.pedidoitem.where('idpedido').equals(idBusca).toArray();
          
          if (itens.length === 0) {
            itens = await db.pedidoitem.where('idpedido').equals(String(idBusca)).toArray();
          }

          if (itens.length === 0) {
            console.warn(`Registro ${pedido.idpedido} sem itens. Pulando...`);
            qtdFalhas++;
            continue; 
          }

          const isOrcamento = parseInt(pedido.orcamento) === 1;

          if (isOrcamento) {

            let nomeCliente = "CLIENTE NÃO IDENTIFICADO";
            if (pedido.idcliente) {
              let clienteDb = await db.cliente.where('idcliente').equals(parseInt(pedido.idcliente)).first();
              if (!clienteDb) {
                clienteDb = await db.cliente.where('idcliente').equals(String(pedido.idcliente)).first();
              }
              if (!clienteDb) {
                const tabelaLeads = this.getTabelaLeads();
                if (tabelaLeads) {
                  const idNum = parseInt(pedido.idcliente);
                  let lead = null;
                  if (!isNaN(idNum)) {
                    lead = await tabelaLeads.get(idNum) || await tabelaLeads.where('cllidclienteprecadastro').equals(idNum).first();
                  }
                  if (lead && lead.cllnome) {
                    clienteDb = { nome: lead.cllnome };
                  }
                }
              }
              if (clienteDb && clienteDb.nome) {
                nomeCliente = clienteDb.nome;
              }
            }

            const listaItensOrcamento = itens.map(item => ({
              ID_CorTamanhoFinal: item.idcortamanhofinal, 
              QT_Produto: item.quantidade,                
              VL_Unitario: item.valorunitario,
              NO_Item: item.ordem,   
              UM: item.UN,
              NM_Produto: item.descricao,
              NM_Marca: item.marca,
              DescricaoComplementar: item.observacao,
              OVIVlrLiquido: (item.valorunitario - item.valordesconto),
              SN_ItemAlternativo: 'N',
            }));

            const payloadOrcamento = {
              ID_Orcamento: pedido.idpedido,
              DT_Orcamento: this.formatarDataSQL(pedido.data),
              ID_Empresa: this.idEmpresa || 1,
              ID_Cliente: pedido.idcliente,
              NM_Cliente: nomeCliente,
              IdPlanoPag: pedido.idplanopagto,
              UsuarioLogado: this.nomeVendedor,
              IdFormaPagto: pedido.idformapagto,  
              IdVendedor: pedido.idvendedor,
              ORVDataEnvioWebApp: this.formatarDataSQL(new Date()),
              ORVOrigemOrcamento: 'WebAPP',
              ListaItem: listaItensOrcamento
            };

            let rotaOrcamento = 'orcamento/set-orcamento';
            let verboRequisicao = 'POST';

            if (pedido.idorcamentoback) {
              rotaOrcamento = `orcamento/${pedido.idorcamentoback}`;
              verboRequisicao = 'PUT';
            }

            const result = await this.fetchWcf(rotaOrcamento, payloadOrcamento, verboRequisicao);
            
            const idGeradoNaApi = result ? (result.IdOrcamento || pedido.idorcamentoback) : null; 

            if (idGeradoNaApi) {
              const dataHoraExata = this.formatarDataSQL(new Date());
              
              await db.pedido.update(pedido.idpedido, { 
                atendido: 1,
                idorcamentoback: idGeradoNaApi,
                datatransmissao: dataHoraExata,
                dataenvio: dataHoraExata
              });

              const idsItens = itens.map(i => i.id);
              if (idsItens.length > 0) {
                  await db.pedidoitem.bulkPut(itens.map(i => ({ ...i, atendido: 1, idorcamentoback: idGeradoNaApi })));
              }
              qtdOrcamentosEnviados++;
              
              pedido.idservidor = idGeradoNaApi;

              try {
                const qtdClientes = await this.processarEnvioClientesLeadDoPedido(pedido.idcliente);
                qtdClientesEnviados += qtdClientes;
              } catch (eCliente) {
                console.error(`Erro ao enviar cliente para o orçamento ${pedido.idpedido}:`, eCliente);
              }

              try {
                const qtdVisitas = await this.processarEnvioVisitasDoPedido(pedido.idpedido, null, idGeradoNaApi);
                qtdVisitasEnviadas += qtdVisitas;
              } catch (eVisita) {
                console.error(`Erro ao enviar visitas para o orçamento ${pedido.idpedido}:`, eVisita);
              }

              try { 
                await this.tentarEnviarEmailCliente(pedido, isOrcamento); 
              } catch (errorEmail) {
                console.error(`Orçamento ${pedido.idpedido} transmitido, mas falha ao enviar e-mail:`, errorEmail);
              }
            } else {
              throw new Error(`Servidor não retornou o IdOrcamento para o registro ${pedido.idpedido}`);
            }

          } else {
            const listaItensFormatada = itens.map(item => ({
              NO_Item: item.ordem,            
              ID_CorTamanhoFinal: item.idcortamanhofinal, 
              QT_Produto: item.quantidade,                
              VL_Unitario: item.valorunitario,
              DC_descricaoProduto: item.descricao,      
              ObservacaoItem: item.observacao || "",      
              ValorTotal: (item.quantidade * (item.valorunitario - item.valordesconto)),
              VL_Liquido: (item.valorunitario - item.valordesconto),
              VL_Desconto: item.valordesconto,
              PE_Desconto: item.percdesconto,
              Iddestinoitemvenda: 1,                      
              MovimentacaoKit: 'N',                       
              PedidoEmpenho: 'N',
              ID_Orcamento: pedido.idorcamentoback,
            }));

            const payload = {
              Id_Pedido: pedido.idpedido,
              DT_Pedido: this.formatarDataSQL(pedido.data),
              ID_Empresa: this.idEmpresa || 1,
              ID_Representante: pedido.idvendedor,
              ID_Cliente: pedido.idcliente,
              ID_PlanoPagamento: pedido.idplanopagto, 
              IDTIPOPEDIDO: pedido.idtipopedidovenda || null,
              ID_FormaPagamento: pedido.idformapagto || null,
              Observacao: pedido.observacao || "",
              FormaInclusaoPedido: 'D',
              observacaovaifatura: 'S', 
              modalidadefrete: '0',
              nm_modalidadefrete: '0 - CIF (EMITENTE)',
              CalculaImposto: 'N',
              PedidoEmpenho: 'N',
              PE_Comissao: 0,
              PEVDataEnvioWebApp: this.formatarDataSQL(new Date()),
              PEVDataConversaoOrcamentoPedido: pedido.dataconversao,
              PEVOrigemPedido: 'WebAPP',
              ListaItem: listaItensFormatada
            };

            if (pedido.idorcamentoback) {
              let nomeCliente = "CLIENTE NÃO IDENTIFICADO";
              if (pedido.idcliente) {
                let clienteDb = await db.cliente.where('idcliente').equals(parseInt(pedido.idcliente)).first();
                if (!clienteDb) clienteDb = await db.cliente.where('idcliente').equals(String(pedido.idcliente)).first();
                if (!clienteDb) {
                  const tabelaLeads = this.getTabelaLeads();
                  if (tabelaLeads) {
                    const idNum = parseInt(pedido.idcliente);
                    let lead = null;
                    if (!isNaN(idNum)) {
                      lead = await tabelaLeads.get(idNum) || await tabelaLeads.where('cllidclienteprecadastro').equals(idNum).first();
                    }
                    if (lead && lead.cllnome) {
                      clienteDb = { nome: lead.cllnome };
                    }
                  }
                }
                if (clienteDb && clienteDb.nome) nomeCliente = clienteDb.nome;
              }

              const listaItensOrcamento = itens.map(item => ({
                ID_CorTamanhoFinal: item.idcortamanhofinal,
                QT_Produto: item.quantidade,
                VL_Unitario: item.valorunitario,
                NO_Item: item.ordem,
                UM: item.UN,
                NM_Produto: item.descricao,
                NM_Marca: item.marca,
                DescricaoComplementar: item.observacao,
                OVIVlrLiquido: (item.valorunitario - item.valordesconto),
                SN_ItemAlternativo: 'N',
              }));

              const payloadFechamento = {
                ID_Orcamento: pedido.idorcamentoback,
                DT_Orcamento: this.formatarDataSQL(pedido.data),
                DataFechamento: this.formatarDataSQL(new Date()),
                ID_Empresa: this.idEmpresa || 1,
                ID_Cliente: pedido.idcliente,
                NM_Cliente: nomeCliente,
                IdPlanoPag: pedido.idplanopagto,
                UsuarioLogado: this.nomeVendedor,
                IdFormaPagto: pedido.idformapagto,  
                IdVendedor: pedido.idvendedor,
                ListaItem: listaItensOrcamento
              };

              try {
                await this.fetchWcf(`orcamento/${pedido.idorcamentoback}`, payloadFechamento, 'PUT');
                // console.log(`Orçamento ${pedido.idorcamentoback} atualizado e fechado com sucesso.`);
              } catch (erroPut) {
                console.error(`Falha ao dar PUT no fechamento do orçamento ${pedido.idorcamentoback}:`, erroPut);
              }
            }

            const result = await this.fetchWcf('pedido/set-pedidos', payload);
            
            const idGeradoNaApi = result ? result.IdPedido : null;

            if (idGeradoNaApi) {
              const dataHoraExata = this.formatarDataSQL(new Date());
              await db.pedido.update(pedido.idpedido, { 
                atendido: 1,
                idpedidoback: idGeradoNaApi,
                datatransmissao: dataHoraExata,
                dataenvio: dataHoraExata
              });

              const idsItens = itens.map(i => i.id);
              if (idsItens.length > 0) {
                  await db.pedidoitem.bulkPut(itens.map(i => ({ ...i, atendido: 1, idpedidoback: idGeradoNaApi })));
              }
              qtdPedidosEnviados++;
              
              pedido.idservidor = idGeradoNaApi;

              try {
                const qtdClientes = await this.processarEnvioClientesLeadDoPedido(pedido.idcliente);
                qtdClientesEnviados += qtdClientes;
              } catch (eCliente) {
                console.error(`Erro ao enviar cliente para o pedido ${pedido.idpedido}:`, eCliente);
              }

              try {
                const qtdVisitas = await this.processarEnvioVisitasDoPedido(pedido.idpedido, idGeradoNaApi, pedido.idorcamentoback || null);
                qtdVisitasEnviadas += qtdVisitas;
              } catch (eVisita) {
                console.error(`Erro ao enviar visitas para o pedido ${pedido.idpedido}:`, eVisita);
              }

              try {
                await this.tentarEnviarEmailCliente(pedido);
              } catch (errorEmail) {
                console.error(`Pedido ${pedido.idpedido} transmitido, mas falha ao enviar e-mail:`, errorEmail);
              }
            } else {
              throw new Error(`Servidor não retornou o IdPedido para o registro ${pedido.idpedido}`);
            }
          }

        } catch (e) {
          console.error(`Erro ao enviar registro ID ${pedido.idpedido}:`, e);
          qtdFalhas++;
        }
      }

      return { pedidos: qtdPedidosEnviados, orcamentos: qtdOrcamentosEnviados, visitas: qtdVisitasEnviadas, clientes: qtdClientesEnviados, falhas: qtdFalhas };
    },

    async tentarEnviarEmailCliente(pedido) {
      this.statusMensagem = `Gerando PDF Pedido ${pedido.idpedido}...`;

      let cliente = await db.cliente.where('idcliente').equals(parseInt(pedido.idcliente)).first();
      if(!cliente) cliente = await db.cliente.where('idcliente').equals(String(pedido.idcliente)).first();

      if (!cliente || !cliente.email) {
          return;
      }

      let nomeDoVendedor = "Departamento de Vendas"; 
      
      let idParaBuscar = pedido.idvendedor || pedido.idrepresentante || this.idVendedor;

      if (idParaBuscar) {
          try {
              let vendedorDb = null;
              const idInt = parseInt(idParaBuscar);
              const idStr = String(idParaBuscar);

              if (!isNaN(idInt)) {
                  vendedorDb = await db.vendedor.where('idvendedor').equals(idInt).first();
              }

              if (!vendedorDb) {
                  vendedorDb = await db.vendedor.where('idvendedor').equals(idStr).first();
              }

              if (!vendedorDb && !isNaN(idInt)) {
                  vendedorDb = await db.vendedor.where('codigo').equals(idInt).first();
              }

              if (vendedorDb) {
                  // console.log("[Email] Vendedor encontrado no banco:", vendedorDb);
                  nomeDoVendedor = vendedorDb.vennome || vendedorDb.nome || vendedorDb.apelido || nomeDoVendedor;
              } else {
                  console.warn("[Email] Vendedor não encontrado no banco de dados local.");
              }

          } catch (err) {
              console.error("[Email] Erro ao buscar nome do vendedor:", err);
          }
      } else {
          console.warn("[Email] Nenhum ID de vendedor identificado.");
      }
      

      const pdfBlob = await this.$refs.geradorPdf.gerarPdfBlob(pedido.idpedido);
      
      if (pdfBlob) {
          this.statusMensagem = `Enviando E-mail Pedido ${pedido.idpedido}...`;
          await this.enviarEmailApi(cliente, pedido, pdfBlob, nomeDoVendedor);
      }
  },

    async enviarEmailApi(cliente, pedido, pdfBlob, nomeRemetente, isOrcamento = false) { 
        const configSmtp = await this.getParametrosSmtp(); 
        const nomeFinal = nomeRemetente || "Departamento de Vendas";
        const nomeDocumento = isOrcamento ? 'Orçamento' : 'Pedido de Venda';
        const nomeArquivo = isOrcamento ? 'Orcamento' : 'Pedido';

        const jsonBody = {
            conexao: {
                host: configSmtp.host,
                porta: configSmtp.porta,
                seguro: configSmtp.seguro,
                email: configSmtp.emailAuth,
                senha: configSmtp.senhaAuth
            },
            email: {
                nome:`Vendedor: ${nomeFinal}`,
                destinatario: cliente.email,
                assunto: `${nomeDocumento} #${pedido.idpedido}`,
                html: `
                    <h3>Olá, ${cliente.nome || 'Cliente'}</h3>
                    <p>Seu ${nomeDocumento.toLowerCase()} número <strong>${pedido.idpedido}</strong> foi processado com sucesso.</p>
                    <p>Segue em anexo o PDF com os detalhes.</p>
                    <br>
                    <p>Atenciosamente,<br>${nomeFinal}</p>
                `
            }
        };

        const formData = new FormData();
        formData.append('json', JSON.stringify(jsonBody));
        formData.append('pedido.pdf', pdfBlob, `${nomeArquivo}_${pedido.idpedido}.pdf`)

        const urlEmail = `${this.urlApiNodeEmail}/email/envio`;

        const headers = {};

        try {
          const registroEmpresa = await db.empresa.limit(1).first();
          if (registroEmpresa && registroEmpresa.EMPChaveAppVenda) {
            headers['Authorization'] = registroEmpresa.EMPChaveAppVenda;
          }
        } catch (err) {
          console.warn("Erro ao buscar chave para envio de email:", err);
        }

        const response = await fetch(urlEmail, {
            method: 'POST',
            headers: headers,
            body: formData
        });

        if (!response.ok) {
            if (response.status === 401) {
                throw new Error("Acesso Negado ao enviar Email: Chave da Empresa Inválida.");
            }
            throw new Error(`Erro API Email: ${response.statusText}`);
        }
    },

    async getParametrosSmtp() {
      const param = await db.empresa.limit(1).first();
      let hostConfig = 'smtp.gmail.com';
      let portaConfig = 465;
      let emailConfig = '';
      let senhaConfig = '';

      if (param) {

          if (param.HostSmtpNfe) hostConfig = param.HostSmtpNfe; // Desativado usa sempre Gmail
          
          if (param.PortaSmtpNfe) {
              const portaParseada = parseInt(param.PortaSmtpNfe);
              if (!isNaN(portaParseada) && portaParseada > 0) {
                  portaConfig = portaParseada;
              }
          }

          emailConfig = param.Email || '';
          senhaConfig = param.SenhaSmtpNfe || 'iwpm bdaj mkmc kaie';

      } else {
          console.warn("Nenhum parâmetro de configuração encontrado no Dexie. Usando padrões.");
      }

      return {
        host: hostConfig,
        porta: portaConfig,
        seguro: true, 
        emailAuth: emailConfig, 
        senhaAuth: senhaConfig
      };
    },

    async enviarTransmissao() {
      if (!navigator.onLine) {
        this.dialogSemConexao = true;
        return;
      }
      
      if (!this.baseUrl) {
        this.dialogUrl = true;
        return;
      }

      const selecionados = this.listaFiltrada.filter(item => item.selecionado);
      if (selecionados.length === 0) {
        this.dialogResultado = {
          show: true,
          title: 'Atenção',
          message: 'Selecione ao menos um registro para realizar o envio.',
          icon: 'mdi-alert-circle-outline',
          color: 'warning'
        };
        return;
      }
      
      this.dialogConfirmar = true;
    },

    async iniciarTransmissao() {
      this.dialogConfirmar = false;
      this.loading = true;
      
      try {
        let totalPedidos = 0;
        let totalOrcamentos = 0;
        let totalVisitas = 0;
        let totalClientes = 0;
        let totalFalhas = 0;

        if (this.filtroTipo === 'precadastro') {
          const resultadoEnvio = await this.processarEnvioPrecadastrosSelecionados();
          totalClientes = resultadoEnvio.clientes;
          totalFalhas = resultadoEnvio.falhas;
        } else {
          const resultadoEnvio = await this.processarEnvioPedidos(); 
          totalPedidos = resultadoEnvio.pedidos;
          totalOrcamentos = resultadoEnvio.orcamentos;
          totalVisitas = resultadoEnvio.visitas;
          totalClientes = resultadoEnvio.clientes || 0;
          totalFalhas = resultadoEnvio.falhas;

          try {
            const visitasSemPedido = await this.processarEnvioVisitasSemPedido();
            totalVisitas += visitasSemPedido;
          } catch (eVisitasSemPedido) {
            console.error("Erro ao enviar visitas sem pedido:", eVisitasSemPedido);
          }

          try {
            const clientesSemPedido = await this.processarEnvioClientesLeadSemPedido();
            totalClientes += clientesSemPedido;
          } catch (eClientesSemPedido) {
            console.error("Erro ao enviar clientes/pré-cadastros sem pedido:", eClientesSemPedido);
          }
        }
        
        if (totalPedidos === 0 && totalOrcamentos === 0 && totalVisitas === 0 && totalClientes === 0) {
          if (totalFalhas > 0) {
            this.dialogResultado = {
              show: true,
              title: 'Atenção na Transmissão',
              message: `Não foi possível enviar os dados. <b>${totalFalhas} registro(s) falhou.</b><br>Tente novamente.`,
              icon: 'mdi-alert-outline',
              color: 'error'
            };
          } else {
            this.dialogResultado = {
              show: true,
              title: 'Aviso',
              message: 'Nenhum dado pendente foi encontrado para envio.',
              icon: 'mdi-information-outline',
              color: 'primary'
            };
          }
        } else {
          let mensagemFinal = 'Transmissão processada!<br><br>';
          
          if (totalPedidos > 0) mensagemFinal += `<b>Pedidos gerados no servidor:</b> ${totalPedidos}<br>`;
          if (totalOrcamentos > 0) mensagemFinal += `<b>Orçamentos gerados:</b> ${totalOrcamentos}<br>`;
          if (totalVisitas > 0) mensagemFinal += `<b>Visitas enviadas:</b> ${totalVisitas}<br>`;
          if (totalClientes > 0) mensagemFinal += `<b>Clientes (Pré-cadastro) enviados:</b> ${totalClientes}<br>`;
          
          if (totalFalhas > 0) {
            mensagemFinal += `<br><b style="color: #d32f2f;">Atenção:</b> ${totalFalhas} registro(s) não puderam ser enviados e continuam pendentes na tela.`;
            this.dialogResultado = {
              show: true,
              title: 'Transmissão Parcial',
              message: mensagemFinal,
              icon: 'mdi-alert-circle-outline',
              color: 'warning'
            };
          } else {
            this.dialogResultado = {
              show: true,
              title: 'Sucesso',
              message: mensagemFinal,
              icon: 'mdi-check-circle-outline',
              color: 'primary'
            };
          }
        }

        await this.carregarPedidos();
        await this.carregarPrecadastros();

      } catch (error) {
        console.error("Erro Crítico Transmissão:", error);
        
        const isOfflineError = !navigator.onLine || error.message.includes("Falha de Conexão");

        if (isOfflineError) {
          this.dialogResultado = {
            show: true,
            title: 'Dispositivo Offline',
            message: 'Parece que você está sem internet no momento ou o servidor está inacessível.<br><br><b>Não se preocupe!</b> Seus dados estão salvos com segurança no seu aparelho. Tente transmitir novamente quando estiver conectado.',
            icon: 'mdi-wifi-off',
            color: 'warning'
          };
        } else {
          this.dialogResultado = {
            show: true,
            title: 'Erro na Transmissão',
            message: `Ocorreu um problema geral durante o envio.<br>Detalhes: ${error.message}`,
            icon: 'mdi-alert-outline',
            color: 'error'
          };
        }

      } finally {
        this.loading = false;
      }
    },

    formatarDataSQL(dataInput) {
      if (!dataInput) return null;
      
      const d = new Date(dataInput);
      if (isNaN(d.getTime())) return null;

      const ano = d.getFullYear();
      const mes = String(d.getMonth() + 1).padStart(2, '0');
      const dia = String(d.getDate()).padStart(2, '0');
      const horas = String(d.getHours()).padStart(2, '0');
      const minutos = String(d.getMinutes()).padStart(2, '0');
      const segundos = String(d.getSeconds()).padStart(2, '0');
      return `${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos}`;
    },
  },

  watch: {
    '$route.query': {
      immediate: true, 
      deep: true,
      handler() {
        this.carregarPedidos();
        this.carregarPrecadastros();
      },
    },
    filtroTipo() {
      this.pedidos.forEach(pedido => {
        pedido.selecionado = false;
      });
      this.precadastros.forEach(item => {
        item.selecionado = false;
      });
    }
  },
};
</script>

<style scoped>
.container-pedido{
  padding: 0;
  margin: 0;
}

.header-fixo {
  justify-content: center;
  position: fixed;
  width: 100%;
  margin: -12px 0 0 0;
  z-index: 3;
  background-color: #eeeeee; 
  padding: 12px 0 12px 0;
}

.lista-com-padding {
  padding-top: 150px;
  padding-bottom: 30px;
}

.card {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.card__consumidor {
  /* padding: 8px 12px; */
  font-size: 0.98rem;
  color: white;
  background-color: #4c6faf;
}

.escrito__card{
  font-size: 0.81rem;
}


.card__detalhe {
  display: flex;
  align-items: center;
  padding: 0 16px 0 16px;
  flex-grow: 1;
}

.card__detalhe__icone-wrapper {
  margin-right: 16px;
}

.card__detalhe-conteudo {
  flex-grow: 1;
  font-size: 0.9rem;
}

.card__detalhe-conteudo > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.table-scroll-container {
  max-height: 255px; 
  padding-right: 10px;
}
.table-scroll-container ::v-deep .simplebar-scrollbar::before {
  background: rgba(76, 111, 175, 0.4) !important;
}

.gerador-pdf-fantasma {
  position: absolute;
  top: -9999px;
  left: -9999px;
  opacity: 0;
  pointer-events: none;
  z-index: -1;
}


@media (min-width: 960px) {
  .header-fixo {
    justify-content: center;
    position: fixed;
    width: 80%;
    margin: 0;
    z-index: 3;
    background-color: #eeeeee; 
  }

  .lista-com-padding {
    justify-content: center;
    margin: auto;
    width: 80%;
    padding-top: 130px;
  }

  .buton-add {
    padding-right: 16px;
  }
}
</style>